import styled from 'styled-components';
import {MainScreenDefaultBox} from './main-screen.default.box';

export const MainScreenCipBox = styled(MainScreenDefaultBox)`
    /* Allows to scroll to the bottom of the screen */
    padding-bottom: 2.5rem;
`;
